<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p>Original text © 2013 by Minna Murra, Inc.<br/>Illustrations © 2013 by Pamela Dalton.</p>
<p>Acknowledgments of permission to reprint previously published materials appear on <span href="#/xhtml/13index#page_53" title="Link target outside of Sample">page 53</span>, which constitutes as an extension of this copyright page.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN 978-1-4521-2963-1<br/>The Library of Congress has cataloged the previous edition as follows:<br/>ISBN 978-1-4521-1339-5</p>
<p>Design by Amelia May Mack.<br/>Calligraphy by Anne Robin.<br/>Photographs by Matthew Carden.<br/>Typeset in Hoefler &amp; Frere-Jones Requiem.</p>
<p>Handprint Books is an imprint of<br/>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, CA 94107<br/><a href="http://www.chroniclebooks.com/titles/kids-teens" target="_blank">www.chroniclekids.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06copyright.vue?1a7596a0